export default __webpack_public_path__ + "static/media/POSitouchCloud.41e3e288.gif";